// eslint-disable-next-line import/extensions
import services from '../services/notice.js'
import { message } from 'antd'

const { getNotice } = services

const namespace = 'notice'

export default {
  namespace,
  state: {
		noticeData: {
			pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      total: 0,
      list: []
		},
		serviceData: {
			pageNo: 1,
      pageSize: 0,
      pageTotal: 0,
      total: 0,
      list: []
		}
  },

  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },

  effects: {
	// 更新数据
	*update({ payload, callback }, { put }) {
		yield put({
			type: 'updateState',
			payload: { ...payload },
		})
	},

	// 获取公告信息
	*getNotice({ payload, callback }, { call, put, select }) {
		const res = yield call(getNotice, payload)
		if(res.success){
			yield put({
				type: 'updateState',
				payload: {
					noticeData: res.data,
				},
			})
		}
	},

	// 获取会员服务信息信息
	*getNews({ payload, callback }, { call, put, select }) {
			const res = yield call(getNotice, payload)
			if(res.success){
				yield put({
						type: 'updateState',
						payload: {
							serviceData: res.data,
						},
				})
			}
    },
  },
  // 订阅事件
  subscriptions: {},
}
